export default "__VITE_ASSET__Bqug6wKS__"